// Translations for NANDA SÁ (FR / EN / PT)
export const translations = {
 fr: {
 nav: {
 group: "Le Groupe",
 brands: "Marques",
 about: "À propos",
 contact: "Contact",
 menu: "Menu",
 close: "Fermer",
 },
 common: {
 discover: "Découvrir",
 learnMore: "En savoir plus",
 contactUs: "Nous contacter",
 backHome: "Retour à l'accueil",
 sinceYear: "Depuis 2023",
 submit: "Envoyer",
 sending: "Envoi…",
 fieldRequired: "Champ requis",
 success: "Votre message a bien été envoyé. Merci.",
 error: "Une erreur est survenue. Réessayez plus tard.",
 },
 home: {
 heroOverline: "Guinée-Bissau · depuis 2023",
 heroTitle: "Un groupe pluriel, enraciné en Afrique de l'Ouest, ouvert sur le monde.",
 heroLede:
 "NANDA SÁ rassemble cinq maisons qui partagent une même exigence : transformer les ressources, les savoir-faire et les territoires d'Afrique de l'Ouest en expériences haut de gamme.",
 cta: "Explorer nos marques",
 sectionGroupOverline: "Le Groupe",
 sectionGroupTitle: "Une vision, cinq maisons.",
 sectionGroupBody:
 "Né d'une volonté de réconcilier patrimoine et modernité, NANDA SÁ développe des activités qui dialoguent entre elles, du goût au geste, de l'habitat à l'énergie, de la transmission à la croissance.",
 brandsOverline: "Nos Maisons",
 brandsTitle: "Cinq expressions d'un même art.",
 footprintOverline: "Empreinte",
 footprintTitle: "Trois ancrages, une même attention.",
 footprintBody:
 "Présents à Canchungo (Guinée-Bissau) et à (Guinée-Bissau), nous opérons avec une équipe locale dans chaque région, pour rester fidèles à nos origines et précis dans l'exécution.",
 ctaTitle: "Construisons ensemble.",
 ctaBody: "Partenariats, distribution, presse, recrutement, nos équipes sont à votre écoute.",
 },
 brands: {
 'nanda-sa': {
 tagline: "Épicerie fine d'Afrique de l'Ouest",
 description:
 "NANDA SÁ sélectionne et révèle les produits naturels d'Afrique de l'Ouest : épices rares, huiles vierges, céréales anciennes. Chaque référence est issue de filières traçables, travaillées avec des producteurs partenaires.",
 story:
 "Du grain au flacon, NANDA SÁ défend une approche artisanale et exigeante. Notre catalogue se construit comme une carte sensible, celle d'un continent qui a beaucoup à offrir, sans rien céder sur la qualité.",
 catalogTitle: "Sélection",
 },
 cosmetiques: {
 tagline: "Cosmétiques naturels, soins essentiels",
 description:
 "NANDA SÁ Cosmétiques conçoit des cosmétiques naturels au croisement de la pharmacopée ouest-africaine et de la formulation contemporaine. Karité, baobab, moringa : nos formules privilégient la sobriété, l'efficacité et le rituel.",
 story:
 "Nous croyons que le soin doit être un geste choisi. NANDA SÁ Cosmétiques propose des produits courts, sans superflu, pensés pour durer dans la salle de bain comme dans le temps.",
 catalogTitle: "Soins",
 },
 energia: {
 tagline: "Solutions solaires professionnelles",
 description:
 "NANDA SÁ ENERGIA PRO déploie des solutions solaires pour entreprises et collectivités. Études, installation, maintenance, nous accompagnons la transition énergétique avec exigence technique et clarté contractuelle.",
 story:
 "L'énergie solaire est une évidence pour notre région. Notre mission : la rendre fiable, rentable et accessible à grande échelle.",
 catalogTitle: "Services",
 },
 "john-tado": {
 tagline: "Maison d'art de vivre africain",
 description:
 "JOHN TĀDO est une Maison, pas une boutique. Une destination curatée célébrant les plus belles expressions du savoir-vivre ouest-africain.",
 story:
 "Élégance héritée. Style choisi. JOHN TĀDO rassemble décoration, mobilier, parfums, arts de la table, mode, livres, objets d'art, épicerie fine, cafés et thés dans une expérience Maison.",
 catalogTitle: "Univers",
 },
 academie: {
 tagline: "Formation et accompagnement",
 description:
 "NANDA SÁ Académie accompagne les talents, entrepreneurs et organisations d'Afrique de l'Ouest à travers des programmes de formation, de mentorat et de structuration stratégique.",
 story:
 "Nous formons les générations qui feront la prochaine décennie de la région, avec rigueur, exigence et un sens profond du collectif.",
 catalogTitle: "Programmes",
 },
 },
 about: {
 overline: "À propos",
 title: "Une maison-mère, un cap clair.",
 lede:
 "NANDA SÁ est une holding familiale fondée pour fédérer des activités complémentaires autour d'une vision commune : faire émerger des marques d'Afrique de l'Ouest qui se mesurent aux meilleures au monde.",
 pillarsTitle: "Nos principes",
 pillars: [
 {
 title: "Exigence",
 body: "Chaque détail compte. Nous travaillons lentement, avec précision, pour livrer un standard inatta­quable.",
 },
 {
 title: "Enracinement",
 body: "Nos racines guident nos choix : matières, partenaires, territoires, récits.",
 },
 {
 title: "Indépendance",
 body: "Capital familial, décisions long terme, liberté d'arbitrage, au service d'un projet patient.",
 },
 {
 title: "Élégance",
 body: "La forme et le fond. L'expérience client comme le produit. Toujours.",
 },
 ],
 locationsTitle: "Implantations",
 locations: [
 { city: "Canchungo", country: "Guinée-Bissau", role: "Siège & sourcing" },
 { city: "Bafatá", country: "Guinée-Bissau", role: "Bureau régional" },
 ],
 },
 contact: {
 overline: "Contact",
 title: "Écrivez-nous.",
 lede: "Nous lisons chaque message. Indiquez la marque concernée si votre demande est spécifique.",
 name: "Nom",
 email: "Email",
 company: "Société (optionnel)",
 brand: "Marque concernée",
 brandAny: "Le Groupe",
 message: "Message",
 send: "Envoyer le message",
 },
 footer: {
 tagline: "Guinée-Bissau · depuis 2023",
 navTitle: "Navigation",
 brandsTitle: "Marques",
 contactTitle: "Contact",
 rights: "Tous droits réservés.",
 },
 },
 en: {
 nav: { group: "The Group", brands: "Brands", about: "About", contact: "Contact", menu: "Menu", close: "Close" },
 common: {
 discover: "Discover",
 learnMore: "Learn more",
 contactUs: "Get in touch",
 backHome: "Back to home",
 sinceYear: "Since 2023",
 submit: "Send",
 sending: "Sending…",
 fieldRequired: "Required",
 success: "Your message has been sent. Thank you.",
 error: "Something went wrong. Please try again later.",
 },
 home: {
 heroOverline: "Guinea-Bissau · since 2023",
 heroTitle: "A plural group, rooted in West Africa, open to the world.",
 heroLede:
 "NANDA SÁ brings together five houses with a shared standard: turning West African resources, craft and territories into premium experiences.",
 cta: "Explore our brands",
 sectionGroupOverline: "The Group",
 sectionGroupTitle: "One vision, five houses.",
 sectionGroupBody:
 "Born from the will to reconcile heritage and modernity, NANDA SÁ develops complementary activities, from taste to gesture, from home to energy, from learning to growth.",
 brandsOverline: "Our Houses",
 brandsTitle: "Five expressions of one craft.",
 footprintOverline: "Footprint",
 footprintTitle: "Three anchors, one care.",
 footprintBody:
 "Present in Canchungo (Guinea-Bissau) and (Guinea-Bissau), we operate with a local team in each region, faithful to our origins, precise in execution.",
 ctaTitle: "Let's build together.",
 ctaBody: "Partnerships, distribution, press, recruitment, our teams will be glad to hear from you.",
 },
 brands: {
 'nanda-sa': {
 tagline: "Fine West African groceries",
 description:
 "NANDA SÁ curates and reveals West Africa's natural foods: rare spices, virgin oils, heirloom grains. Every reference is sourced through traceable chains, hand-in-hand with partner producers.",
 story: "From grain to bottle, NANDA SÁ defends a craft-first, demanding approach. Our catalogue reads like a sensitive map, that of a continent with much to offer, with no compromise on quality.",
 catalogTitle: "Selection",
 },
 cosmetiques: {
 tagline: "Natural cosmetics, essential care",
 description:
 "NANDA SÁ Cosmétiques designs natural cosmetics at the crossroads of West African pharmacopeia and contemporary formulation. Shea, baobab, moringa: sobriety, efficacy, ritual.",
 story: "Care should be a chosen gesture. NANDA SÁ Cosmétiques offers short, no-frills products designed to last, on the shelf and in time.",
 catalogTitle: "Care",
 },
 energia: {
 tagline: "Professional solar solutions",
 description:
 "NANDA SÁ ENERGIA PRO deploys solar solutions for businesses and institutions. Studies, installation, maintenance, we accompany the energy transition with technical rigour and contractual clarity.",
 story: "Solar energy is an obvious choice for our region. Our mission: make it reliable, profitable and broadly accessible.",
 catalogTitle: "Services",
 },
 "john-tado": {
 tagline: "African lifestyle House",
 description:
 "JOHN TĀDO is a House, not a store. A curated destination celebrating the finest expressions of West African lifestyle.",
 story: "Inherited Elegance. Chosen Style. JOHN TĀDO brings together decoration, furniture, fragrances, tableware, fashion, books, art objects, gourmet delicatessen, coffee and tea in a House experience.",
 catalogTitle: "Universes",
 },
 academie: {
 tagline: "Training & coaching",
 description:
 "NANDA SÁ Académie supports talent, entrepreneurs and organisations across West Africa through training, mentorship and strategic structuring.",
 story: "We train the generations who will shape the next decade of the region, with rigour, demand and a deep sense of the collective.",
 catalogTitle: "Programs",
 },
 },
 about: {
 overline: "About",
 title: "One parent company, a clear course.",
 lede:
 "NANDA SÁ is a family-owned holding founded to unite complementary activities around a shared vision: building West African brands that compete with the world's best.",
 pillarsTitle: "Our principles",
 pillars: [
 { title: "Demand", body: "Every detail matters. We work slowly, precisely, to deliver an uncompromising standard." },
 { title: "Roots", body: "Our roots guide our choices: materials, partners, territories, stories." },
 { title: "Independence", body: "Family capital, long-term decisions, freedom to choose, in service of a patient project." },
 { title: "Elegance", body: "Form and substance. Customer experience and product. Always." },
 ],
 locationsTitle: "Locations",
 locations: [
 { city: "Canchungo", country: "Guinea-Bissau", role: "Head office & sourcing" },
 { city: "Bafatá", country: "Guinea-Bissau", role: "Regional office" },
 ],
 },
 contact: {
 overline: "Contact",
 title: "Write to us.",
 lede: "We read every message. Mention the relevant brand if your request is specific.",
 name: "Name",
 email: "Email",
 company: "Company (optional)",
 brand: "Brand",
 brandAny: "The Group",
 message: "Message",
 send: "Send message",
 },
 footer: {
 tagline: "Guinea-Bissau · since 2023",
 navTitle: "Navigation",
 brandsTitle: "Brands",
 contactTitle: "Contact",
 rights: "All rights reserved.",
 },
 },
 pt: {
 nav: { group: "O Grupo", brands: "Marcas", about: "Sobre", contact: "Contacto", menu: "Menu", close: "Fechar" },
 common: {
 discover: "Descobrir",
 learnMore: "Saber mais",
 contactUs: "Contactar-nos",
 backHome: "Voltar ao início",
 sinceYear: "Desde 2023",
 submit: "Enviar",
 sending: "A enviar…",
 fieldRequired: "Obrigatório",
 success: "A sua mensagem foi enviada. Obrigado.",
 error: "Ocorreu um erro. Tente novamente mais tarde.",
 },
 home: {
 heroOverline: "Guiné-Bissau · desde 2023",
 heroTitle: "Um grupo plural, enraizado na África Ocidental, aberto ao mundo.",
 heroLede:
 "A NANDA SÁ reúne cinco casas com uma mesma exigência: transformar os recursos, os saberes e os territórios da África Ocidental em experiências de excelência.",
 cta: "Explorar as marcas",
 sectionGroupOverline: "O Grupo",
 sectionGroupTitle: "Uma visão, cinco casas.",
 sectionGroupBody:
 "Nascido da vontade de conciliar património e modernidade, o NANDA SÁ desenvolve actividades complementares, do paladar ao gesto, do habitat à energia, da transmissão ao crescimento.",
 brandsOverline: "As Nossas Casas",
 brandsTitle: "Cinco expressões de uma mesma arte.",
 footprintOverline: "Presença",
 footprintTitle: "Três ancoragens, uma mesma atenção.",
 footprintBody:
 "Em Canchungo (Guiné-Bissau) e (Guinea-Bissau), operamos com equipa local em cada região, fiéis às origens e rigorosos na execução.",
 ctaTitle: "Vamos construir juntos.",
 ctaBody: "Parcerias, distribuição, imprensa, recrutamento, as nossas equipas estão à escuta.",
 },
 brands: {
 'nanda-sa': {
 tagline: "Mercearia fina da África Ocidental",
 description:
 "A NANDA SÁ selecciona e revela os produtos naturais da África Ocidental: especiarias raras, óleos virgens, cereais antigos. Cada referência vem de fileiras rastreáveis, em parceria com produtores.",
 story: "Do grão ao frasco, a NANDA SÁ defende uma abordagem artesanal e exigente.",
 catalogTitle: "Selecção",
 },
 cosmetiques: {
 tagline: "Cosméticos naturais, cuidados essenciais",
 description:
 "A NANDA SÁ Cosmétiques concebe cosméticos naturais entre a farmacopeia oeste-africana e a formulação contemporânea. Karité, baobá, moringa.",
 story: "O cuidado deve ser um gesto escolhido. Produtos curtos, sem supérfluo, feitos para durar.",
 catalogTitle: "Cuidados",
 },
 energia: {
 tagline: "Soluções solares profissionais",
 description:
 "A NANDA SÁ ENERGIA PRO implementa soluções solares para empresas e colectividades. Estudos, instalação, manutenção.",
 story: "A energia solar é uma evidência para a nossa região. A missão: torná-la fiável, rentável, acessível.",
 catalogTitle: "Serviços",
 },
 "john-tado": {
 tagline: "Casa de arte de viver africana",
 description:
 "A JOHN TĀDO é uma Casa, não uma loja. Um destino curado que celebra as mais belas expressões do saber-viver oeste-africano.",
 story: "Elegância herdada. Estilo escolhido. A JOHN TĀDO reúne decoração, mobiliário, fragrâncias, artes de mesa, moda, livros, objectos de arte, mercearia fina, cafés e chás numa experiência de Casa.",
 catalogTitle: "Universos",
 },
 academie: {
 tagline: "Formação e acompanhamento",
 description:
 "A NANDA SÁ Académie acompanha talentos, empresários e organizações na África Ocidental através de programas de formação, mentoria e estruturação estratégica.",
 story: "Formamos as gerações que farão a próxima década da região.",
 catalogTitle: "Programas",
 },
 },
 about: {
 overline: "Sobre",
 title: "Uma casa-mãe, um rumo claro.",
 lede:
 "A NANDA SÁ é uma holding familiar fundada para federar actividades complementares em torno de uma visão comum: fazer emergir marcas da África Ocidental que se medem com as melhores do mundo.",
 pillarsTitle: "Os nossos princípios",
 pillars: [
 { title: "Exigência", body: "Cada detalhe conta. Trabalhamos com lentidão e precisão." },
 { title: "Raízes", body: "As nossas raízes guiam as nossas escolhas." },
 { title: "Independência", body: "Capital familiar, decisões de longo prazo." },
 { title: "Elegância", body: "Forma e substância. Experiência e produto." },
 ],
 locationsTitle: "Implantações",
 locations: [
 { city: "Canchungo", country: "Guiné-Bissau", role: "Sede & sourcing" },
 { city: "Bafatá", country: "Guinea-Bissau", role: "Escritório regional" },
 ],
 },
 contact: {
 overline: "Contacto",
 title: "Escreva-nos.",
 lede: "Lemos cada mensagem. Indique a marca em causa, se necessário.",
 name: "Nome",
 email: "Email",
 company: "Empresa (opcional)",
 brand: "Marca",
 brandAny: "O Grupo",
 message: "Mensagem",
 send: "Enviar mensagem",
 },
 footer: {
 tagline: "Guiné-Bissau · desde 2023",
 navTitle: "Navegação",
 brandsTitle: "Marcas",
 contactTitle: "Contacto",
 rights: "Todos os direitos reservados.",
 },
 },
};

export const SUPPORTED_LOCALES = ["fr", "en", "pt"];
